<script lang="ts">
  import Header from './lib/components/Header.svelte';
  import Home from './routes/Home.svelte';
  import Order from './routes/Order.svelte';
  import Editor from './routes/Editor.svelte';
  import Login from './routes/Login.svelte';
  import DialogHost from './lib/components/DialogHost.svelte';
  import { router } from './lib/router.svelte';

  // Page de connexion admin dédiée, sur le CHEMIN /login (non référencée) —
  // hors du routeur hash de l'app publique, sans header ni nav.
  const isLoginPath =
    typeof window !== 'undefined' &&
    window.location.pathname.replace(/\/+$/, '') === '/login';

  // Le back-office admin (PIM) est en lazy import : son code (et ses
  // dépendances lourdes, ex. la grille du tableur) reste HORS du bundle
  // client public.
  const Admin = import('./routes/Admin.svelte').then((m) => m.default);
</script>

{#if isLoginPath}
  <Login />
{:else}
  <div class="page" class:is-admin={router.current === 'admin'}>
    <Header />

    <!-- Host des dialogs impératifs (alert/confirm/prompt). Monté une
         seule fois ici, rend le dialog courant en top-layer du <dialog>
         natif (z-index parent ignoré). -->
    <DialogHost />

    <main class="main">
      <div class="container">
        {#if router.current === 'home'}
          <Home />
        {:else if router.current === 'order'}
          <Order />
        {:else if router.current === 'editor'}
          <Editor />
        {:else if router.current === 'admin'}
          {#await Admin then AdminRoute}
            <AdminRoute />
          {/await}
        {/if}
      </div>
    </main>
  </div>
{/if}
